export default __webpack_public_path__ + "static/media/wizard.8389f200.png";